import angular from 'angular';
import timingStrategyConstants from './timing-strategy.constants';


const constants = angular.module('ttb.constants', [
    timingStrategyConstants,
]).name;

export default constants;


// WEBPACK FOOTER //
// ../constants/index.js